import {Ban, Check, X} from 'lucide-react'

type ConfirmModalProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  action: 'activate' | 'deactivate'
  count?: number
  loading?: boolean
}

export const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  action,
  count = 0,
  loading = false,
}: ConfirmModalProps) => {
  if (!isOpen) return null
  const isActivate = action === 'activate'

  return (
    <div className='ua-confirm' role='dialog' aria-modal='true' aria-labelledby='ua-confirm-title'>
      <button className='ua-confirm__backdrop' aria-label='Fechar confirmação' onClick={onClose} />
      <div className='ua-confirm__panel'>
        <div className='ua-confirm__header'>
          <span className={`ua-confirm__icon ${isActivate ? '' : 'is-danger'}`}>
            {isActivate ? <Check size={20} /> : <Ban size={20} />}
          </span>
          <div>
            <span>Alteração em massa</span>
            <h3 id='ua-confirm-title'>{isActivate ? 'Liberar acesso' : 'Remover acesso'}</h3>
          </div>
          <button type='button' className='ua-icon-button' aria-label='Fechar' onClick={onClose}>
            <X size={15} />
          </button>
        </div>
        <div className='ua-confirm__body'>
          <p>
            Deseja {isActivate ? 'liberar' : 'remover'} <strong>{title}</strong>{' '}
            {count ? `para ${count} usuário(s) visível(is)` : 'para os usuários visíveis'}?
          </p>
          <small>
            A ação considera os filtros aplicados na matriz e pode ser ajustada individualmente
            depois.
          </small>
        </div>
        <div className='ua-confirm__footer'>
          <button
            type='button'
            className='ua-secondary-button'
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type='button'
            className={isActivate ? 'ua-primary-button' : 'ua-danger-button'}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <span className='ua-spinner' />
            ) : isActivate ? (
              <Check size={15} />
            ) : (
              <Ban size={15} />
            )}
            {loading ? 'Aplicando…' : 'Confirmar alteração'}
          </button>
        </div>
      </div>
    </div>
  )
}
